export const EMAILS = ["username@gmail.com", "user02@gmail.com"];

export const constants = {
    EMBARK_TITLE: 'Embark on a transformative journey of self-discovery and growth!',
    INSTALL_NOW: 'Install Steev app now!',
    ADD_CALENDER: 'Add Calendar',
    COPY_LINK: 'Copy Link',
    SHARE: 'Share',
    BROUGHT_BY: 'Brought to you by',
} 